<template>
    <footer class="mt-2">
        <v-divider></v-divider>
        <v-card-text class="text-center">
            Copyright © {{ new Date().getFullYear() }} — Gapide Limited and its licensors. All rights reserved. <a href="/legal" target="_blank">Legal</a>
        </v-card-text>
    </footer>
</template>

<script>
    export default {
        name: "GapptFooter"
    }
</script>

<style scoped>

</style>
